interface Props {
  roas?: number;
  ctr?: number;
  showTooltip?: boolean;
}

export function PerformanceBadge({ roas, ctr, showTooltip = true }: Props) {
  // Calculate performance status based on ROAS
  const getPerformanceStatus = () => {
    if (roas === undefined || roas === null) {
      return { color: 'gray', label: 'No Data', score: 0, icon: '○' };
    }
    
    if (roas >= 5.0) {
      return { color: 'green', label: 'Excellent', score: 100, icon: '✓' };
    } else if (roas >= 3.0) {
      return { color: 'yellow', label: 'Good', score: 70, icon: '!' };
    } else {
      return { color: 'red', label: 'Needs Attention', score: 40, icon: '✗' };
    }
  };

  const status = getPerformanceStatus();

  const colorClasses = {
    green: 'bg-green-500 text-white border-green-600',
    yellow: 'bg-amber-500 text-black border-amber-600',
    red: 'bg-red-500 text-white border-red-600',
    gray: 'bg-gray-300 text-gray-600 border-gray-400',
  };

  return (
    <div className="relative group inline-block">
      {/* Badge */}
      <div
        className={`flex items-center justify-center w-8 h-8 rounded-full border-2 font-semibold text-xs ${
          colorClasses[status.color as keyof typeof colorClasses]
        }`}
        role="img"
        aria-label={`${status.label} performance`}
        title={showTooltip ? undefined : `${status.label}: ${status.score}`}
      >
        <span className="sr-only">{status.icon}</span>
        <span aria-hidden="true">{status.icon}</span>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-10 pointer-events-none">
          <div className="font-semibold mb-1">{status.label}</div>
          {roas !== undefined && roas !== null && (
            <div className="flex items-center gap-1">
              <span className={`text-${status.color}-400`}>●</span>
              <span>ROAS: {roas.toFixed(1)}x</span>
            </div>
          )}
          {ctr !== undefined && ctr !== null && (
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-blue-400">●</span>
              <span>CTR: {(ctr * 100).toFixed(1)}%</span>
            </div>
          )}
          {/* Tooltip arrow */}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
            <div className="border-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      )}
    </div>
  );
}
